import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl, defineMessages} from 'react-intl';

import {connect, ssr_wait} from '@stubhub/react-store-provider';

import SeoInternalLinks from '../react-seo-internal-links';

import controller from './controller';

import './index.scss';

const messages = defineMessages({
  nearbyCitiesTitle: {
    id: 'NearbyCities.title',
    defaultMessage: 'Cities near {entityName}',
    description: 'View all cities nearby',
  },
});

class NearbyCities extends React.Component {
  @ssr_wait
  init() {
    const {loadNearbyCities} = this.props;

    return loadNearbyCities(this.props);
  }

  UNSAFE_componentWillMount() {
    const {cityLinks} = this.props;
    if (!cityLinks || cityLinks.length === 0) {
      this.init();
    }
  }

  componentWillUnmount() {
    const {resetNearbyCities} = this.props;
    resetNearbyCities();
  }

  render() {
    const {intl, entityName, cityLinks = [], entityType, entityId} = this.props;
    const title = intl.formatMessage(messages.nearbyCitiesTitle, {entityName});

    return cityLinks.length > 0 ? (
      <div className="NearbyCities">
        <SeoInternalLinks
          className="CityPage__NearbyCities"
          entityType={entityType}
          entityId={entityId}
          seoLinks={cityLinks}
          title={title}
        />
      </div>
    ) : null;
  }
}

NearbyCities.propTypes = {
  entityName: PropTypes.string,
  entityId: PropTypes.number,
  entityType: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  lat: PropTypes.number,
  // eslint-disable-next-line react/no-unused-prop-types
  lng: PropTypes.number,
  cityLinks: PropTypes.array,
  loadNearbyCities: PropTypes.func.isRequired,
  resetNearbyCities: PropTypes.func.isRequired,

  /** The intl object */
  intl: PropTypes.object.isRequired,
};

export {NearbyCities};

export default injectIntl(connect(controller)(NearbyCities));
